import React from 'react';
import { createRoot } from 'react-dom/client';
import initIntercom from 'util/intercom';
import { addSentryIntegrations, initSentry } from 'util/sentry';
import { AlertContainer } from '@umai/common';
import AppProvider from 'contexts/AppProvider';
import PartnerProvider from 'contexts/PartnerProvider';
import ThemeProvider from 'contexts/ThemeProvider';
import ErrorBoundary from 'components/ErrorBoundary';
import 'util/global-vars';
import 'styles/base.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

const MOUNT_NODE = document.getElementById('root');

const root = createRoot(MOUNT_NODE);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppProvider>
        <PartnerProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </PartnerProvider>
      </AppProvider>
      <AlertContainer />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

initIntercom();
initSentry();
addSentryIntegrations();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
